import { ROLES } from '@/constants/roles';

export const notification = {
  path: '/notification',
  name: 'notification',
  component: () => import('./index.vue'),
  meta: {
    title: 'Уведомления',
    accessList: [
      ROLES.certificate,
      ROLES.member,
      ROLES.organization,
      ROLES.operator,
      ROLES.department,
      ROLES.trainer,
      ROLES.expert,
      ROLES.moderator,
    ],
    instruction: {
      id: 40,
      name: 'Уведомления',
    },
    icon: 'mdi-pulse',
    layout: 'ui-design',
  },
};

const routes = [notification];

export default routes;
